import { ChatClient } from "@azure/communication-chat";
import { AzureCommunicationTokenCredential } from "@azure/communication-common";
import { CommunicationIdentityClient } from "@azure/communication-identity";

const config = {
    getChatClient: async (token:string): Promise<ChatClient> => {
        const endpointUrl = process.env.REACT_APP_endpointUrl;
        const tokenCredential = new AzureCommunicationTokenCredential(token);
        const chatClient = new ChatClient(endpointUrl!, tokenCredential);
        return chatClient ;
    }
};

export default config;
